import { CategoryEventMetadata, SearchEventMetadata } from "@/types"
import { sessionStore } from "@/core/store"
import { SearchTrackOptions } from "./types"

function createMetadataCache<T>() {
  let metadata: T | undefined

  return {
    get: () => metadata,
    set: (data: T) => {
      metadata = {
        ...(metadata ?? {}),
        ...data
      }
    },
    reset: () => {
      metadata = undefined
    }
  }
}

export const serpMetadataCache = createMetadataCache<SearchEventMetadata>()
export const autocompleteMetadataCache = createMetadataCache<SearchEventMetadata>()
export const categoryMetadataCache = createMetadataCache<CategoryEventMetadata>()

const caches = {
  serp: serpMetadataCache,
  autocomplete: autocompleteMetadataCache,
  category: categoryMetadataCache
} as const

export function getMetadataCache<T extends SearchTrackOptions>(type: T) {
  return caches[type]
}

function createCache(key: `nosto:search:${string}`) {
  return {
    get() {
      return sessionStore.getAsJson<string[]>(key) || []
    },
    push(query: string) {
      const queries = [...this.get(), query]
      sessionStore.setAsJson(key, queries.slice(-100))
    }
  }
}

export const organicQueriesCache = createCache("nosto:search:organicQueries")
export const keywordQueriesCache = createCache("nosto:search:keywordQueries")

let resultId: string | undefined

export const resultIdCache = {
  get: () => resultId,
  set: (value: string) => {
    resultId = value
  }
}
